import { Link, MaterialSymbols } from '@xfers/design-system'
import React from 'react'
import { useDispatch } from 'react-redux'
import { PATHS } from '~/routes/paths'
import { resetDeposit } from '~/store/deposit/actions'
import { redirect } from '~/store/route/actions'
import { resetWithdraw } from '~/store/withdraw/actions'

export default function StraitsXBreadcrumbReturnToHome() {
  const dispatch = useDispatch()
  const onClick = () => {
    resetDeposit()
    resetWithdraw()
    dispatch(redirect(PATHS.LANDING_PAGE))
  }

  return (
    <Link
      typographyType="label"
      size="md"
      textContent="Return to Home"
      onClick={onClick}
      icon={<MaterialSymbols icon="arrow_back" size="s" />}
      iconPlacement="left"
      isUnderlined={false}
    />
  )
}
